import {EntityListPage} from "base/entity";
import {useTable} from "../hooks/Table";

import {CountriesAndRegionsService} from "../countriesandregions/CountriesAndRegionsService";

export const ListPage = () => {
    const {tableColumns} = useTable();

    return (
        <EntityListPage
            views={["table"]}
            entityName="Countries or Regions"
            service={CountriesAndRegionsService}
            tableColumns={tableColumns}
            // mapLayer={useLayer}
            subPage={false}
            // filterForm={<SocioeconomicFilter />}
            downloadButton={false}
        />
    );
};
